import React from 'react'
import CaretLeftIcon from '@tecuity/sos-icons/react/caret-left'
import CaretRightIcon from '@tecuity/sos-icons/react/caret-right'
import PropTypes from 'prop-types'
import './Pager.scss'

const Pager = ({ numPages = 0, activePage, onPrevClicked, onNextClicked, onPageClicked }) => {
  return (
    <div className="pager">
      { activePage === 1 ?
        null
        :
        <button onClick={(e) => onPrevClicked(e)} aria-label="Previous Page">
          <CaretLeftIcon />
        </button>
      }
      {new Array(numPages).fill(null).map((_, i) => (
        <button
          onClick={(e) => onPageClicked(e, i + 1)}
          className={`${activePage === i + 1 ? 'active' : ''}`}
          key={i}
        >
          {i + 1}
        </button>
      ))}
      { activePage === numPages ?
        null
        :
        <button onClick={(e) => onNextClicked(e)} aria-label="Next Page">
          <CaretRightIcon />
        </button>
      }
    </div>
  )
}
Pager.propTypes = {
  numPages: PropTypes.number.isRequired,
  activePage: PropTypes.number,
  onPrevClicked: PropTypes.func.isRequired,
  onNextClicked: PropTypes.func.isRequired,
  onPageClicked: PropTypes.func.isRequired
}

export default Pager



// WEBPACK FOOTER //
// ./src/components/Pager/Pager.js